/* eslint-disable  */
import React from 'react';
import { connect } from 'react-redux';
import CurriculumView from '../components/curriculum-view/curriculum-view.jsx';
import { openCurriculumPanel } from '../reducers/cmra-curriculum.js';
class CmraCurriculum extends React.Component {
  
  render () {
    return (<CurriculumView {...this.props}  />)
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.scratchGui.cmraCurriculum.isOpen,
    content: state.scratchGui.cs2n.content, //TODO: Move this to the cmraCurriculum reducer
  }
}
const mapDispatchToProps = dispatch => ({
  onContentReady: () => dispatch(openCurriculumPanel())
});

export default connect(mapStateToProps, mapDispatchToProps)(CmraCurriculum);
